import React from "react";
import "./InterviewDates.scss";
import { format } from "date-fns";

const InterviewDates = ({ setInterviewDate, interviewDate }) => {
  const today = new Date();
  const tomorrow = new Date();
  const yesterday = new Date();

  tomorrow.setDate(today.getDate() + 1);
  yesterday.setDate(today.getDate() - 1);

  const getNextDay = () => {
    setInterviewDate((prevDate) => {
      const nextDay = new Date(prevDate);
      nextDay.setDate(prevDate.getDate() + 1);
      return nextDay;
    });
  };
  const getPrevDay = () => {
    setInterviewDate((prevDate) => {
      const prevDay = new Date(prevDate);
      prevDay.setDate(prevDate.getDate() - 1);
      return prevDay;
    });
  };

  const isSameDay = (day1, day2) => {
    return day1.toDateString() === day2.toDateString();
  };

  return (
    <div className="interview-dates-container">
      <i
        className={`ri-arrow-left-s-fill pagination-arrow-size cursor-pointer px-0 `}
        onClick={getPrevDay}
      ></i>
      {isSameDay(interviewDate, today) ? (
        <span>Today</span>
      ) : isSameDay(interviewDate, tomorrow) ? (
        <span>Tomorrow</span>
      ) : isSameDay(interviewDate, yesterday) ? (
        <span>Yesterday</span>
      ) : (
        <span>
          {format(interviewDate?.toISOString().split("T")[0], "MMM-dd")}
        </span>
      )}
      <i
        className={`ri-arrow-right-s-fill pagination-arrow-size cursor-pointer px-0 `}
        onClick={getNextDay}
      ></i>
    </div>
  );
};

export default InterviewDates;
